import React, { useCallback } from 'react';

import {
  EcommerceSectionNamespace,
  trackAddToCartEvent,
  trackAddToCartFailedEvent,
  trackFreeDeliveryStatus,
} from '@services/ecommerceService';
import { dispatchMessage, MessagingEvents } from '@services/messagingService';
import { hasFreeDeliveryForCart } from '@utils/delivery';

import { useAddProductAwaitable } from '../../../services';
import { CartActions, ECartActions, IAddProductAction } from '../model';

export const useAddProductToCart = (dispatch: React.Dispatch<CartActions>) => {
  const { request } = useAddProductAwaitable();

  return useCallback(
    async (data: IAddProductAction): Promise<number> => {
      const hadFreeDelivery = hasFreeDeliveryForCart(
        data.minimalPriceLimit,
        data.freeDelivery,
        data.freeDeliveryGlobalLimit,
        data.freeDeliveryGlobalFrom,
        data.freeDeliveryGlobalTo,
        data.benefits,
        data.priceProductsSummary,
        data.discountWithoutDelivery,
      );

      const result = await request({ productId: data.productId, count: data.count });
      const productInCart = result?.data?.products.find((p) => p.productId === data.productId);
      const ecommerceProduct = data.product;

      if (productInCart && result) {
        dispatchMessage({ event: MessagingEvents.ECartManipulationEvents.CART_UPDATE_EVENT });
        dispatch({ actionType: ECartActions.UPDATE_PRODUCTS, payload: result.data });
        ecommerceProduct.listName = EcommerceSectionNamespace.EEcommerceName.FREE_DELIVERY_CROSS_SELL;
        trackAddToCartEvent(ecommerceProduct, 1);

        const gotFreeDelivery = hasFreeDeliveryForCart(
          data.minimalPriceLimit,
          data.freeDelivery,
          data.freeDeliveryGlobalLimit,
          data.freeDeliveryGlobalFrom,
          data.freeDeliveryGlobalTo,
          result.data.benefits,
          result.data.pricesSummary.priceProductsSummary,
          result.data.pricesSummary.discountWithoutDelivery,
        );

        if (!hadFreeDelivery && gotFreeDelivery) {
          trackFreeDeliveryStatus();
        }
        return productInCart.itemId;
      }

      trackAddToCartFailedEvent(ecommerceProduct, 1);

      return 0;
    },
    [dispatch, request],
  );
};
